import { Language } from "@omni/schemas/config/language.schema";

import { Translate } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";

const getLabel = ({
    language,
    variant,
    t
}: {
    language?: Language;
    variant?: "small" | "large";
    t: Translate;
}) => {
    if (language) {
        return variant === "small"
            ? language["language-code"].toUpperCase()
            : `${language["language-name"]} - ${language["language-code"].toUpperCase()}`;
    } else {
        const languageCode = Config.getLanguage().toUpperCase();
        const languageName = t(`general.language.${Config.getLocale()}`);

        return variant === "small"
            ? languageCode
            : `${languageName} - ${languageCode}`;
    }
};

export { getLabel };
